<div class="console_modal device_pair_dialog">
    <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2">
            <span class="badge bg-primary-subtle text-primary p-2">
                <span class="material-symbols-outlined">p2p</span>
            </span>
            <span>Associa</span>
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
    </div>

    <div class="modal-body" [spinnerLoader]="pairSubscription && !pairSubscription.closed">
        <div class="container-fluid">
            <form class="row row-gap-2" novalidate>
                <div class="col-6">
                    <fs-model-select [formField]="pairForm.assetModel" />
                </div>
                <div class="col-6">
                    <label class="form-label" for="parDescription">Descrizione</label>
                    <input type="text" class="form-control" id="parDescription" [formField]="pairForm.description">
                </div>
            </form>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Chiudi</button>
        <button type="button" class="btn btn-primary" (click)="saveModel()">Salva</button>
    </div>
</div>